module.exports = __webpack_public_path__ + "static/img/error.85ff6c5.jpg";